// extracted by mini-css-extract-plugin
export var boxItems = "_8u-1";
export var button = "_8u-5";
export var filterGroupBox = "_8u-0";
export var icon = "_8u-2";
export var iconSecondary = "_8u-4";
export var iconWrapper = "_8u-3";